// extracted by mini-css-extract-plugin
module.exports = {"ad-spend-report":"AdSpendsReport_ad-spend-report__1nn0b","tableContainer":"AdSpendsReport_tableContainer__1-UZX","select":"AdSpendsReport_select__1Nokg"};